module.exports = __webpack_public_path__ + "static/media/map-marker-exclamation.c4daf9d9.svg";